import styled from 'styled-components/macro';
import errorImgSrc from 'assets/images/error-dog.png';

export const ErrorScreenWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  text-align: center;
  padding: 0 20px;
`;

export const ErrorImg = styled.div`
  width: 100%;
  max-width: 500px;
  aspect-ratio: 1 / 1;
  background-image: url(${errorImgSrc});
  background-size: contain;
  background-repeat: no-repeat;
`;
export const ErrorTitle = styled.h1`
  display: block;
  font-size: 2rem;
  font-weight: 500;
  color: #1f2939;
  line-height: 1.25;
  margin-bottom: 16px;
`;

export const ErrorText = styled.p`
  font-size: 1rem;
  color: #1f2939;
  max-width: 410px;
  margin-bottom: 24px;
  white-space: pre-wrap;
  line-height: 1.5;
`;
